import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import { setStorage} from "@/utils";

import { selectLibraryHeader } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {refreshMenu, setLbname, setLibrary, setMenu, setYear,setLibraryArr} from "../../../../redux/common/action";
import {message} from "antd";
import {getStorage} from "../../../../utils";
import {getALLMenu} from "../../../../servers/menuAPI";
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.searchHandler = this.searchHandler.bind(this)
        this.resetHandler = this.resetHandler.bind(this)
        this.onChange = this.onChange.bind(this)
        this.gotobase = this.gotobase.bind(this)
        this.gotodetail = this.gotodetail.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getListData();
    }


    state = {
        columns: [],
        dataSource: tableData.tBody,
        loading: true,
        annuallist:[],
        levellist:[],
        oldlevellist:[],
        provincelist:[],
        indicatorlist:[],
        options:[],
        onsitelist:[],
        reviewlist:[],
        speciallist:[],
        annual:'',
        oldlevelid:'',
        applylevelid:'',
        newlevelid:'',
        provinceid:'',
        museumname:'',
        indicatorid:'',
        minscore:'',
        maxscore:'',
        specialid:'',
        onsite:'',
        review:'',
        type:'',
        width:true
    };

    gotobase(value,str){
        const params = {
            museumid:value,
        }
        selectLibraryHeader(params).then(res=>{
            const result = res.records[0].scorelist
            this.props.setLibraryArr(result)
            this.props.setLibrary(value)
            this.props.setLbname(str)
            localStorage.setItem('chooseid','20131010')
            this.props.history.push({
                pathname: '/informationDeclaration/museumbaseinfo/baseCentral'
            });
            this.props.refreshMenu(true)
        })
    }

    gotodetail(value,str){
        const params = {
            museumid:value,
        }
        selectLibraryHeader(params).then(res=>{
            const result = res.records[0].scorelist
            this.props.setLibraryArr(result)
            this.props.setLibrary(value)
            this.props.setLbname(str)
            localStorage.setItem('chooseid','201318')
            this.props.history.push({
                pathname: '/informationDeclaration/scoredetailCentral'
            });
            this.props.refreshMenu(true)
        })
    }

    searchHandler(){
        this.getListData()
    }

    onChange(data,type){
        this.setState({
            [type]:data
        })
    }

    resetHandler(){
        this.setState({
            annual:'',
            oldlevelid:'',
            applylevelid:'',
            newlevelid:'',
            provinceid:'',
            museumname:'',
            indicatorid:'',
            minscore:'',
            maxscore:'',
            specialid:'',
            onsite:'',
            review:'',
        },()=>{
            this.getListData()
        })
    }

    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = {
            annual:this.state.annual,
            oldlevelid:this.state.oldlevelid,
            applylevelid:this.state.applylevelid,
            newlevelid:this.state.newlevelid,
            indicatorid:this.state.indicatorid,
            minscore:this.state.minscore,
            maxscore:this.state.maxscore,
            specialid:this.state.specialid,
            onsite:this.state.onsite,
            review:this.state.review,
            provinceid:this.state.provinceid === -1 ? '' : this.state.provinceid,
            museumname:this.state.museumname
        }
        selectLibraryHeader(params).then(res=>{
            if (res.statecode == 0) {
                const arr = []
                res.records[0].annuallist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].oldlevellist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].levellist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].provincelist.forEach((item,index)=>{
                    if (index === 0) {
                        item.id = -1
                    }
                    item.value = item.id
                })
                res.records[0].indicatorlist.forEach(item=>{
                    item.value = item.id
                })
                if (this.state.type != 6) {
                    res.records[0].reviewlist.forEach(item=>{
                        item.value = item.id
                    })
                }

                res.records[0].speciallist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].onsitelist.forEach(item=>{
                    item.value = item.id
                })
                let d = JSON.parse(JSON.stringify(res.records[0].scorelist))
                this.setState({
                    dataSource: d,
                    annuallist:res.records[0].annuallist,
                    levellist:res.records[0].levellist,
                    oldlevellist:res.records[0].oldlevellist,
                    provincelist:res.records[0].provincelist,
                    indicatorlist:res.records[0].indicatorlist,
                    reviewlist:res.records[0].reviewlist,
                    speciallist:res.records[0].speciallist,
                    onsitelist:res.records[0].onsitelist,
                    loading:false
                });
            } else {
                message.error(res.statemessage)
                this.setState({
                    loading:false
                })
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }

    componentWillMount(){

    }

    componentDidMount(){
        const type = getStorage('userList').clerklevel
        this.setState({
            columns:type == 6 || type == 7 ? tableData.tHead1 :tableData.tHead
        })
        this.setState({
            type:type,
            width:document.getElementById('user-manage-list').clientWidth > 800 ? true : false
        })
        this.getListData();
    }

    render(){
        return (
            <div className='user-manage-list' id='user-manage-list'>
                <div className='filter-wrap search-block-special'>
                    <div className='flex filter-left' style={{width:'100%',flexWrap:'wrap'}}>
                        <div className='flex filter-left' style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>评估年度</span>
                            <CSelect
                                value={this.state.annual}
                                options={this.state.annuallist}
                                placeholder='请选择评估年度'
                                onChange={(value)=>{this.onChange(value,'annual')}}
                                style={{width:'100px'}}
                            />
                        </div>
                        <div className='flex filter-left'  style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>博物馆现有等级</span>
                            <CSelect
                                value={this.state.oldlevelid}
                                options={this.state.oldlevellist}
                                placeholder='请选择博物馆现有等级'
                                onChange={(value)=>{this.onChange(value,'oldlevelid')}}
                                style={{width:'100px'}}
                            />
                        </div>
                        <div className='flex filter-left'  style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>博物馆申报等级</span>
                            <CSelect
                                value={this.state.applylevelid}
                                options={this.state.levellist}
                                placeholder='请选择博物馆申报等级'
                                onChange={(value)=>{this.onChange(value,'applylevelid')}}
                                style={{width:'100px'}}
                            />
                        </div>
                        <div className='flex filter-left'  style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>博物馆评定等级</span>
                            <CSelect
                                value={this.state.newlevelid}
                                options={this.state.levellist}
                                placeholder='请选择博物馆评定等级'
                                onChange={(value)=>{this.onChange(value,'newlevelid')}}
                                style={{width:'100px'}}
                            />
                        </div>
                        {this.state.type == 6 || this.state.type ==  7 ? '' :
                            <div className='flex filter-left'  style={{marginTop:'20px'}}>
                                <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>博物馆所处省份</span>
                                <CSelect
                                    value={this.state.provinceid}
                                    options={this.state.provincelist}
                                    placeholder='请选择博物馆所处省份'
                                    onChange={(value)=>{this.onChange(value,'provinceid')}}
                                    style={{width:'100px'}}
                                />
                            </div>
                        }
                        <div className='flex filter-left'  style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>博物馆名称</span>
                            <CInput
                                value={this.state.museumname}
                                placeholder='请输入博物馆名称'
                                style={{width:'150px'}}
                                onChange={(value)=>{this.onChange(value,'museumname')}}
                            />
                        </div>
                    </div>
                    <div className='flex filter-left' style={{width:'100%',flexWrap:'wrap'}}>
                        <div className='flex filter-left'  style={{marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>指标项分值</span>
                            <CSelect
                                value={this.state.indicatorid}
                                options={this.state.indicatorlist}
                                placeholder='请选择指标项分值'
                                onChange={(value)=>{this.onChange(value,'indicatorid')}}
                                style={{width:'100px'}}
                            />
                            <CInput
                                value={this.state.minscore}
                                placeholder='请输入分'
                                style={{width:'100px',marginLeft:'50px'}}
                                onChange={(value)=>{this.onChange(value,'minscore')}}
                            />
                            <span style={{width:'30px'}}>分至</span>
                            <div style={{flexDirection:'row'}}>
                                <CInput
                                    value={this.state.maxscore}
                                    placeholder='请输入分'
                                    style={{width:'100px'}}
                                    onChange={(value)=>{this.onChange(value,'maxscore')}}
                                />
                            </div>
                            <span>分</span>
                        </div>
                    </div>
                    <div className='flex filter-left' style={{width:'100%',flexWrap:'wrap'}}>
                        <div className='flex filter-left'  style={this.state.width?{width:'30%',marginTop:'20px'}:{width:'50%',marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>加分项</span>
                            <CRadio value={this.state.specialid}
                                    options={this.state.speciallist}
                                    onChange={(value)=>{this.onChange(value,'specialid')}}
                            />
                        </div>
                        <div className='flex filter-left'  style={this.state.width?{width:'30%',marginTop:'20px'}:{width:'50%',marginTop:'20px'}}>
                            <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>现场考察</span>
                            <CRadio value={this.state.onsite}
                                    options={this.state.onsitelist}
                                    onChange={(value)=>{this.onChange(value,'onsite')}}
                            />
                        </div>
                        {
                            this.state.type != 6 &&
                            <div className='flex filter-left'  style={this.state.width?{width:'30%',marginTop:'20px'}:{width:'50%',marginTop:'20px'}}>
                                <span style={{width:'100px',fontWeight:'bold',textAlign:'right'}}>评议调整</span>
                                <CRadio value={this.state.review}
                                        options={this.state.reviewlist}
                                        onChange={(value)=>{this.onChange(value,'review')}}
                                />
                            </div>
                        }

                    </div>
                    <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
                    <CButton onClick={this.resetHandler} style={{marginLeft:'20px',marginTop:'20px'}}>重置</CButton>
                </div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} page={this.state.page}>
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {index+1}
                            </div>
                        )} />
                    <div
                        slot='operate'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotobase(record.id,record.name)}>查看</CButton>
                            </div>
                        )} />
                    <div
                        slot='detail'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotodetail(record.id,record.name)}>查看</CButton>
                            </div>
                        )} />
                </CTable>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReload: bindActionCreators(setReload, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        setYear:bindActionCreators(setYear,dispatch),
        setLibrary:bindActionCreators(setLibrary,dispatch),
        setLibraryArr:bindActionCreators(setLibraryArr,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
        refreshMenu: bindActionCreators(refreshMenu, dispatch),
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
